export default __webpack_public_path__ + "static/media/cv151-7.46e74e06.png";